import { type Command } from "@telespot/core";

/**
 * Registration token for {@link MoveCases}
 *
 * @group Workspaces
 * @category Tokens
 */
export const MOVE_CASES = "move:cases";

/**
 * Details for {@link MoveCases}
 *
 * @group Workspaces
 * @category Payloads
 */
export interface MoveCaseDetails {
  caseId: string;
  workspaceId: string;
}

/**
 * Moves a case to a given workspace, if the case and the workspace are compatible.
 * Compatibility is defined the same way as for {@link CopyCases}
 *
 * //TODO: rename to MoveCases (singular)
 *
 * @group Workspaces
 * @category Commands
 */
export class MoveCases implements Command<typeof MOVE_CASES, MoveCaseDetails> {
  public readonly name = MOVE_CASES;

  constructor(public readonly details: MoveCaseDetails) { }
}
